module.exports = __webpack_public_path__ + "static/media/hospital_closures_collage_s_s_s_s_dox.783b2cc1.jpg";